import { AppConfig } from '../../../core/services/app-config.service';
import { HandsetService } from '../../../core/services/handset.service';
import { Liability } from '../../models/liability.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { EditLiabilityForm } from '../../forms/edit-liability.form';
import {  ISO_PATTERN } from 'src/app/shared/configs/date-config';
import { LiabilitySource } from '../../../billers/models/model';

@Component({
standalone: false,
  selector: 'app-edit-liability-dialog',
  templateUrl: './edit-liability-dialog.component.html',
  styleUrls: ['./edit-liability-dialog.component.scss'],
})
export class EditLiabilityDialogComponent implements OnInit {
  form: EditLiabilityForm;

  formName = 'editLiability';
  isoPattern: string = ISO_PATTERN;
  minDate: Date;
  maxDate: Date;




  MIN_AMOUNT = 0.01;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Liability,
    public handsetService: HandsetService,
    public appConfig: AppConfig,
    private dialogRef: MatDialogRef<EditLiabilityDialogComponent>,
  ) {
    this.minDate = new Date();
    this.maxDate = new Date();
    this.minDate.setMonth(this.minDate.getMonth() - 3);
    this.maxDate.setMonth(this.maxDate.getMonth() + 12);
  }

  ngOnInit() {
    let isScan = ((this.data.source === LiabilitySource.MANUAL_SCANNING) ||
      (this.data.source === LiabilitySource.EMAIL_FORWARD));
    this.form = new EditLiabilityForm(
      this.data.title,
      this.data.amount,
      new Date(this.data.paymentDue),
      this.appConfig,
      (this.data.source === LiabilitySource.TOP_UP),
      isScan,
    );
  }

  save() {
    if (this.form.valid) {
      const editLiabilityData = this.form.getFinalData();
      this.dialogRef.close({ editLiabilityData, liabilityId: this.data.id });
    }
  }

  get title() {
    return 'Edycja wydatku ' + this.data.billerName;
  }

}
